export default "__VITE_ASSET__Ez6MIv0Y__"